import { inject, DependencyContainer } from 'tsyringe'
import { containerScoped } from '~/decorators/dependency-container'
import { requestContainerToken } from '~/constants/dependency-injection/tokens'
import InternalFormValidationBuilder from '~/builders/form/InternalFormValidationBuilder'
import { Ref } from '@nuxtjs/composition-api'

@containerScoped()
export default class FormValidationBuilder {
  constructor(
    @inject(requestContainerToken) private requestContainer: DependencyContainer
  ) {}

  new(
    error?: Ref<string | null>,
    key: string | null = null
  ): InternalFormValidationBuilder {
    const formValidationBuilder = this.requestContainer.resolve(
      InternalFormValidationBuilder
    )
    if (error) {
      formValidationBuilder.error = error
      formValidationBuilder.key = key as string
    }
    return formValidationBuilder
  }
}
